import axios from "axios";

/**
 * Authorization ヘッダ値が「実トークンを含まない空の Bearer」か判定する。
 * "Bearer "(空)・空白のみ・大文字小文字ゆれ("bearer " 等)を対象にする。
 * FEコード内に bearer(小文字)で組み立てている箇所も実在するため、/i で大小無視する。
 */
export const isBlankBearer = (raw: unknown): boolean =>
  typeof raw === "string" && raw.replace(/^Bearer\s*/i, "").trim() === "";

/**
 * ひろば HttpOnly Cookie 認証(FQM-467)の axios 設定。
 *
 * 認証トークンは BE が発行する HttpOnly Cookie(__Host-hiroba_token)にのみ置き、FE は保持しない。
 *  - 全リクエストで Cookie を送る(withCredentials)。
 *    axios の呼び出し先は全て自社BE(serverEnv の env_*_url)のため、送信先での絞り込みはしない。
 *  - 各所が手貼りする "Authorization: Bearer "(トークンは常に空)をリクエスト前に落とす。
 *    → サーバ側(TokenFromCookie)の Cookie→Bearer 詰め替えが発火し Cookie で認証される。
 *    (トークン付与が約34ファイルに散在し中央化されていないため、一括で対応する)
 */
export const setupHirobaAuth = (): void => {
  axios.defaults.withCredentials = true;

  axios.interceptors.request.use((config) => {
    const headers = config.headers as Record<string, unknown> | undefined;
    if (headers) {
      const raw = headers.Authorization ?? headers.authorization;
      // 実トークンが無い空の Bearer はヘッダごと落として Cookie 認証に委ねる。
      if (isBlankBearer(raw)) {
        delete headers.Authorization;
        delete headers.authorization;
      }
    }
    return config;
  });
};
